import { UndoAction } from './UndoAction';

export class UndoActionBuffer
{
  _undoHTML:string;
  _redoHTML:string;
  _actions:Array<UndoAction>;

  get undoHTML():string{ return this._undoHTML; }
  get redoHTML():string{ return this._redoHTML; }

  constructor( undoHTML:string, redoHTML:string, actions:Array<UndoAction> )
  {
    this._undoHTML = undoHTML;
    this._redoHTML = redoHTML;
    this._actions = actions;
  }
    
  async redo():Promise<void>
  {
    for ( let i=0; i<this._actions.length; i++)
    {
      await this._actions[i].redo();
    }
    return Promise.resolve();
  }
  
  async undo():Promise<void>
  {
    for ( let i = this._actions.length - 1; i >= 0; i-- )
    {
      await this._actions[i].undo();
    }

    return Promise.resolve();
  }
  
  release()
  {
    for ( var i = 0; i < this._actions.length; i++ )
    {
      if ( this._actions[ i ].release )
      { this._actions[i].release(); }
    }
  }
}